import { DateTime } from "luxon";

import { ajaxController } from "./controller/AjaxController";
import { PagedResult } from "../DTOs/Common/PagedResult";
import { PlantTypeDTO } from "../DTOs/PlantTypeDTO";
import { DataTableFilteredRequest } from "../components/DataTable/TableHook";
import { PlantJobTypeDTO } from "../DTOs/PlantJobTypeDTO";
import { PlantDTO } from "../DTOs/Plants/PlantDTO";
import { DoubleShift, TripleShift } from "../types/Shift";

export class PlantAjax {
  private _ajaxController = ajaxController;
  private _plantDataEndpoint = "/Plant";

  // Plant Job Types
  async getPlantJobTypes() {
    return this._ajaxController.get<PagedResult<PlantJobTypeDTO>>(
      `${this._plantDataEndpoint}/plant-job-types`, {}
    );
  }

  // Plant Types
  async getPlantType(id: number) {
    return this._ajaxController.get<PlantTypeDTO>(
      `${this._plantDataEndpoint}/plant-types/${id}`,
      {}
    );
  }

  async getPlantTypes(filters: DataTableFilteredRequest) {
    return this._ajaxController.get<PagedResult<PlantTypeDTO>>(
      `${this._plantDataEndpoint}/plant-types`,
      filters
    );
  }

  async updatePlantType(data: PlantTypeDTO) {
    return this._ajaxController.put<PlantTypeDTO>(
      `${this._plantDataEndpoint}/plant-types/${data.id}`,
      data
    );
  }

  async addPlantType(data: PlantTypeDTO) {
    return this._ajaxController.post<PlantTypeDTO, PlantTypeDTO>(
      `${this._plantDataEndpoint}/plant-types`,
      data
    );
  }

  async deletePlantType(id: number) {
    return this._ajaxController.delete(
      `${this._plantDataEndpoint}/plant-types/${id}`
    );
  }

  // multiple stoppage plants
  async getMultipleStoppagePlants(shiftDate: DateTime, dayNightAfternoon: TripleShift, timeIn: DateTime, timeOut?: DateTime, jobTypes?: number) {
    return this._ajaxController.post<object, PlantDTO[]>(
      `${this._plantDataEndpoint}/multiple-stoppage-plants/${shiftDate.toISODate()}/${dayNightAfternoon[0]}`,
      {
        timeIn: timeIn,
        timeOut: timeOut,
        jobTypes: jobTypes
      }
    );
  }

  // Digging
  public getAvailableDiggers(shiftDate: DateTime, dayOrNight: DoubleShift) {
    return this._ajaxController.get<PagedResult<PlantDTO>>(
      `${this._plantDataEndpoint}/available-diggers/${shiftDate.toISODate()}/${dayOrNight[0]}`, {}
    )
  }

  public getAvailableTrucks(shiftDate: DateTime, dayOrNight: DoubleShift) {
    return this._ajaxController.get<PagedResult<PlantDTO>>(
      `${this._plantDataEndpoint}/available-trucks/${shiftDate.toISODate()}/${dayOrNight[0]}`, {}
    )
  }
}

export const plantAjax = new PlantAjax();